var map = {
	"./en-CA-Dialogue.json": [
		79411,
		411
	],
	"./en-US-LEGAL.json": [
		80833,
		833
	],
	"./en-US.json": [
		5335,
		335
	],
	"./fr-CA-Devdialo.json": [
		38277,
		277
	],
	"./fr-CA-Dialogue.json": [
		67788,
		788
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 75314;
module.exports = webpackAsyncContext;